import { useRef, useEffect } from 'react'
import { useAppSelector } from './useAppSelector'
import { selectUnsaved } from '../store/selectors/configSelectors'
import { selectLicenseState } from '../store/selectors/licenceSelectors'

const useUnload = (fn: any) => {
  const unsaved = useAppSelector(selectUnsaved)
  const licenceState = useAppSelector(selectLicenseState)

  const cb = useRef(fn)

  useEffect(() => {
    cb.current = fn
  }, [fn])

  const isUnsaved = Object.values(unsaved).includes(true)

  useEffect(() => {
    const onUnload = (...args: any) => {
      cb.current?.(...args)
    }
    if (isUnsaved) {
      window.addEventListener('beforeunload', onUnload)
      return () => window.removeEventListener('beforeunload', onUnload)
    }
  }, [unsaved, licenceState]) // eslint-disable-line
}

export default useUnload
